import React from 'react'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { registerUser } from '../../services/authService';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Register = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {loader, errors:errorsResponse, isSuccess} = useSelector((state) => state.auth);

    const { register, handleSubmit, watch, reset, formState: { errors } } = useForm();
    const password = watch('password');
    
    const onSubmit = (data) => {
      dispatch(registerUser(data));
      if (isSuccess) reset();
    }

  return (
    <>
    {errorsResponse?.length > 0 && 
        <div className="toastContent">
            {errorsResponse?.map((error, key) =>
         
              toast.error(error, {
                position: toast.TOP_CENTER,
                autoClose: 5000,
                className: 'bg-red-100 text-red-700 border border-red-400 rounded-md',
                bodyClassName: 'font-medium',
                key : {key},
                progressClassName: 'bg-red-500',
              })
            )}
        </div>
    } 
    
    {isSuccess && 
        toast.success(t('notifs.success'), {
          position: toast.TOP_RIGHT,
        })
    }  
  
   <div className="flex justify-center items-center h-screen">
      <form onSubmit={handleSubmit(onSubmit)} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 w-full max-w-sm">
        <h2 className="text-2xl font-bold mb-4 text-center">{t('register.title')}</h2>
        
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">{t('register.form.userName.label')}</label>
          <input
            {...register("username", { required: t('register.form.userName.required'),
                minLength: { 
                    value: 6, 
                    message: t('register.form.userName.message')
                  },
                  maxLength: {
                    value: 12, 
                    message: t('register.form.userName.max')
                  }
             })}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
          />
            {errors.username && <p className="text-red-500 text-xs mt-1">{errors.username.message}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">{t('register.form.firstName.label')}</label>
          <input
            {...register("firstName", { required: t('register.form.firstName.required'),
                minLength: { 
                    value: 6, 
                    message: t('register.form.firstName.message')
                  }

             })}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
          />
            {errors.firstName && <p className="text-red-500 text-xs mt-1">{errors.firstName.message}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">{t('register.form.lastName.label')}</label>
          <input
            {...register("lastName", { required: t('register.form.lastName.required'),
                minLength: { 
                    value: 6, 
                    message: t('register.form.lastName.message')
                  }
             })}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
          />
            {errors.lastName && <p className="text-red-500 text-xs mt-1">{errors.lastName.message}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">{t('register.form.email.label')}</label>
          <input
            type="email"
            {...register("email", { 
                required: t('register.form.email.required'), 
                pattern: { 
                  value:  /^[^\s@]+@[^\s@]+\.[^\s@]+$/, 
                  message: t('register.form.email.message') 
                }
              })}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
          />
           {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
       
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">{t('register.form.password.label')}</label>
          <input
            type="password"
            {...register("password", { 
                required: t('register.form.password.required'), 
                minLength: { 
                  value: 4, 
                  message:  t('register.form.password.message') 
                },
                validate: {
                  hasUppercase: (value) =>
                    /[A-Z]/.test(value) || t('register.form.password.upperLetter'),
                  hasNumber: (value) =>
                    /[0-9]/.test(value) || t('register.form.password.number')
                }
              })}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
          />
            {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>}
        </div>
        <div  className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2">{t('register.form.password.labelConfirm')}</label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
          type="password"
          {...register('confirmPassword', {
            required: t('register.form.password.required'),
            validate: {
              hasUppercase: (value) =>
                /[A-Z]/.test(value) || t('register.form.password.upperLetter'),
              hasNumber: (value) =>
                /[0-9]/.test(value) || t('register.form.password.number'),
              matchesPassword: (value) =>
                value === password || 'Passwords do not match',
            },
  
          })}
        />
        {errors.confirmPassword && <p className="text-red-500 text-xs mt-1">{errors.confirmPassword.message}</p>}
      </div>

        <button
          type="submit"
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full" disabled = {loader}
        >
        {t('register.form.button')}
        </button>
      </form>
    </div>
    </>
  )
}

export default Register